import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icon_13.png'


const _withScopeId = n => (_pushScopeId("data-v-cd47ff4a"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "wh-14",
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ml-8 fz-14 lh-36" }, "导入", -1))

import { ref, withDefaults, getCurrentInstance } from 'vue';

	interface main {
		data ?: any
	}

	
export default /*#__PURE__*/_defineComponent({
  __name: 'ImportBtn',
  props: {
    data: { default: {} }
  },
  emits: ["change"],
  setup(__props: any, { emit: __emit }) {

	const props = __props;
	
	const { proxy } = getCurrentInstance() as any;
	const ImportFilePop = ref<any>();
	const emits = __emit

	const ShowImportFile = () => {
		if (!props.data.upapi) {
			proxy.$message.error("暂未开放");
			return false;
		}
		ImportFilePop.value.open({
			name: props.data.name,
			downapi: props.data.downapi,
			downname: props.data.downname,
			upapi: props.data.upapi,
			data: props.data.data,
		});
	};

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_ImportFile = _resolveComponent("ImportFile")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_button, {
      class: "import-btn",
      plain: "",
      type: "primary",
      onClick: ShowImportFile
    }, {
      default: _withCtx(() => [
        _hoisted_1,
        _hoisted_2
      ]),
      _: 1
    }),
    _createVNode(_component_ImportFile, {
      ref_key: "ImportFilePop",
      ref: ImportFilePop,
      onChange: _cache[0] || (_cache[0] = ($event: any) => (emits('change')))
    }, null, 512)
  ]))
}
}

})